import { useEffect, useState } from "react";

const TARGET = new Date("2026-12-31T17:00:00Z");

const calc = () => {
  const diff = TARGET - new Date();
  if (diff <= 0) return null;
  return {
    Tage: Math.floor(diff / 86400000),
    Std: Math.floor((diff / 3600000) % 24),
    Min: Math.floor((diff / 60000) % 60),
    Sek: Math.floor((diff / 1000) % 60),
  };
};

export const SilvesterCountdown = () => {
  const [left, setLeft] = useState(calc);

  useEffect(() => {
    const t = setInterval(() => setLeft(calc()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!left) return null;

  return (
    <div className="mb-14 text-center" data-testid="silvester-countdown">
      <p className="text-amber-300/90 text-sm tracking-widest uppercase mb-5">Noch so lange bis zur Silvesterparty</p>
      <div className="inline-flex items-stretch gap-2 sm:gap-4">
        {Object.entries(left).map(([label, val]) => (
          <div
            key={label}
            className="w-16 sm:w-24 py-3 sm:py-4 rounded-2xl bg-amber-400/10 border border-amber-400/40 backdrop-blur-md shadow-lg shadow-amber-500/10"
          >
            <span
              className="block text-2xl sm:text-4xl font-bold text-amber-300 tabular-nums"
              data-testid={`silvester-countdown-${label.toLowerCase()}`}
            >
              {label === "Tage" ? val : String(val).padStart(2, "0")}
            </span>
            <span className="block text-[10px] sm:text-xs uppercase tracking-wider text-slate-300 mt-1">{label}</span>
          </div>
        ))}
      </div>
      <p className="text-slate-300 text-sm mt-5">Sichert euch jetzt eure Plätze – VIP-Tickets sind begrenzt!</p>
    </div>
  );
};
